
export default class State {
  // eslint-disable-next-line no-useless-constructor
  constructor (context) {
  }

  mouseDown (context, e) {
    return this;
  }

  mouseMove (context, e) {
    return this;
  }

  mouseUp (context, e) {
    return this;
  }

  dispose () {
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/fillet/states/state.js